var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 3.5H5.833A2.34 2.34 0 0 0 3.5 5.833v16.334A2.34 2.34 0 0 0 5.833 24.5H14v-8.167h-2.333v-2.887H14v-2.392c0-2.524 1.414-4.298 4.394-4.298l2.103.002v3.04h-1.396c-1.16 0-1.601.87-1.601 1.677v1.972h2.996l-.663 2.886H17.5V24.5h4.667a2.34 2.34 0 0 0 2.333-2.333V5.833A2.34 2.34 0 0 0 22.167 3.5Z",
    fill: "#fff"
  })));
};
export default SvgFacebook;